import React, { useEffect } from 'react';
import { useTrustyActor, useTrustyState } from './TrustyProvider';
import { trustyConstants as c } from '../lib/trusty.constants';
import { useParams } from 'react-router-dom';
import { TrustyUI } from './TrustyUI/TrustyUI';
import { TrustyGameItem } from './TrustyGameItem/TrustyGameItem';

import css from './TrustyGame.module.css';

export const TrustyGame = () => {
  const { id } = useParams();
  const { send } = useTrustyActor();
  const state = useTrustyState();

  useEffect(() => {
    send({ type: c.events.START, lessonId: id });
  }, [id, send]);

  const isIdle = state.matches(c.states.idle);
  const isPlaying = state.matches('set1Playing') || state.matches('set2Playing') || 
                    state.matches(c.states.paused1) || state.matches(c.states.paused2);
  const isPaused = state.matches(c.states.paused1) || state.matches(c.states.paused2);

  if (isIdle) return <div className={css.loading}>Завантаження словника...</div>;

  return (
    <div className={css.container}>
      <div className={css.mainArea}>
        {isPlaying ? (
          <div className={css.gameArea}>
            <TrustyGameItem />
          </div>
        ) : (
          <div className={css.gameOverContent}>
             <TrustyUI mode="content" />
          </div>
        )}
      </div>
      <div className={css.footerArea}>
        <TrustyUI mode={isPlaying ? (isPaused ? "paused" : "playing") : "actions"} />
      </div>
    </div>
  );
};
